import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list (params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(`${url}/activityTariffs`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/activityTariffs/${id}?include=activity,tariff`, options)
        .then(response => {
            let tariffActivity = jsona.deserialize(response.data);
            delete tariffActivity.links;
            return tariffActivity;
        });
}


function show (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/activityTariffs/${id}`, options)
        .then(response => {
            let activityTariff = jsona.deserialize(response.data);
            delete activityTariff.links;
            return activityTariff;
        });
}

function add (activityTariff) {
    const payload = jsona.serialize({
        stuff: activityTariff,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/activityTariffs?include=activity`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update (activityTariff) {
    const payload = jsona.serialize({
        stuff: activityTariff,
        includeNames: ['activity','guidance','workplace']
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/activityTariffs/${activityTariff.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/activityTariffs/${id}`, options);
}

export default {
    list,
    get,
    show,
    add,
    update,
    destroy
};

